import Checkbox from '@ubnt/ui-components/Checkbox/Checkbox';
import { memo, useCallback } from 'react';

interface DisableRadioCheckboxProps {
  id: string;
  value: boolean;
  onChange: (newValue: boolean) => void;
}

const DisableRadioCheckboxImpl = (props: DisableRadioCheckboxProps) => {
  const { id, value, onChange: onChangeProp } = props;

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChangeProp(event.target.checked);
    },
    [onChangeProp]
  );

  return (
    <Checkbox checked={value} id={id} onChange={onChange}>
      Disable Radio
    </Checkbox>
  );
};

const DisableRadioCheckbox = memo(DisableRadioCheckboxImpl);

export default DisableRadioCheckbox;
